export default __webpack_public_path__ + "static/media/amar.73a5f865.png";